import axios from "axios";
import { URL_REGISTER, URL_access } from "../utils/endpoints";

export interface LoginForm {
  email: string;
  senha: string;
}

export interface RegisterForm {
  [key: string]: unknown;
}

export const SignInUser = async (form: LoginForm): Promise<unknown> => {
  const response = await axios.post(URL_access, form);
  return response.data;
};

export const SignUpUser = async (form: RegisterForm): Promise<unknown> => {
  const response = await axios.post(URL_REGISTER, form);
  return response.data;
};
